import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import {
  BUGSNAG_API_KEY,
  BUGSNAG_RELEASE_STAGE,
  REPO_VERSION,
  AMPLITUDE_API_KEY,
} from "@/env";

import amplitude from "amplitude-js";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type PubSub from "pubsub-js";

const amplitudeClient = amplitude.getInstance();
amplitudeClient.init(AMPLITUDE_API_KEY);
if (REPO_VERSION) {
  amplitudeClient.setVersionName(REPO_VERSION);
}

export { amplitudeClient };

export const bugsnagClient = Bugsnag.start({
  apiKey: BUGSNAG_API_KEY,
  enabledReleaseStages: ["production", "stage"],
  releaseStage: BUGSNAG_RELEASE_STAGE,
  appVersion: REPO_VERSION,
  onError: (report) => {
    // eslint-disable-next-line no-unused-expressions
    window.newrelic?.noticeError(report.originalError);
  },
  plugins: [new BugsnagPluginReact()],
});

export const ErrorBoundary = bugsnagClient
  .getPlugin("react")!
  .createErrorBoundary(React);
